// first1

// firebaseConfig.js
// import firebase from "firebase/compat/app";
// import "firebase/compat/firestore";
// import { getAuth } from "firebase/auth";
// import { getStorage } from "firebase/storage";
// import { getFirestore } from "firebase/firestore";

// // const firebaseConfig = {
// //   apiKey: "",
// //   authDomain: "temporary-astra-products.firebaseapp.com",
// //   projectId: "",
// //   storageBucket: "",
// //   messagingSenderId: "601318019111",
// //   appId: "",
// //   // databaseURL: "",
// // };

// const firebaseConfig = {
//   apiKey: "AIzaSyATaLsyhJe8KEqyMxnfEcaHAntBzzI6FSs",
//   authDomain: "temporary-astra-products.firebaseapp.com",
//   projectId: "temporary-astra-products",
//   storageBucket: "temporary-astra-products.firebasestorage.app",
//   messagingSenderId: "601318019111",
//   appId: "1:601318019111:web:792299a2fb5b1fbbcebe02",
//   // databaseURL: "gs://blockchain-demo-bab7a.appspot.com",
// };

// export const app = firebase.initializeApp(firebaseConfig);
// export const db = app.firestore();
// export const db_modular = getFirestore(app);
// export const storage = getStorage(app);
// export const auth = getAuth(app);

// firebaseConfig.js

// sec2
// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";
// import { getStorage } from "firebase/storage";

// const firebaseConfig = {
//   apiKey: "AIzaSyATaLsyhJe8KEqyMxnfEcaHAntBzzI6FSs",
//   authDomain: "temporary-astra-products.firebaseapp.com",
//   projectId: "temporary-astra-products",
//   storageBucket: "temporary-astra-products.firebasestorage.app",
//   messagingSenderId: "601318019111",
//   appId: "1:601318019111:web:792299a2fb5b1fbbcebe02",
//   // databaseURL: "gs://blockchain-demo-bab7a.appspot.com",
// };

// export const app = initializeApp(firebaseConfig);

// export const auth = getAuth(app);
// export const db_modular = getFirestore(app);
// export const storage = getStorage(app);

//third
// firebaseConfig.js

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";

// Your Firebase config
// const firebaseConfig = {
//   apiKey: "AIzaSyATaLsyhJe8KEqyMxnfEcaHAntBzzI6FSs",
//   authDomain: "temporary-astra-products.firebaseapp.com",
//   projectId: "temporary-astra-products",
//   storageBucket: "temporary-astra-products.firebasestorage.app",
//   messagingSenderId: "601318019111",
//   appId: "1:601318019111:web:792299a2fb5b1fbbcebe02",
// };

const firebaseConfig = {
  apiKey: "AIzaSyATaLsyhJe8KEqyMxnfEcaHAntBzzI6FSs",
  authDomain: "temporary-astra-products.firebaseapp.com",
  projectId: "temporary-astra-products",
  storageBucket: "temporary-astra-products.firebasestorage.app",
  messagingSenderId: "601318019111",
  appId: "1:601318019111:web:792299a2fb5b1fbbcebe02",
  // databaseURL: "gs://blockchain-demo-bab7a.appspot.com",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

// 🔥 v8 style exports
export const db = app.firestore();
export const db_modular = app.firestore(); // keep for your existing code
export const auth = app.auth();
export const storage = app.storage();

export default app;
